import { createSlice } from '@reduxjs/toolkit';
import { sendLicenseInvoice } from './thunk';

export interface ISendLicenseInvoiceState {
  isSendingInvoice?: boolean;
}

const initialState: ISendLicenseInvoiceState = {
  isSendingInvoice: false
};

const sendLicenseInvoiceSlice = createSlice({
  name: 'sendLicenseInvoice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendLicenseInvoice.pending, (state) => {
        state.isSendingInvoice = true;
      })
      .addCase(sendLicenseInvoice.fulfilled, (state) => {
        state.isSendingInvoice = false;
      })
      .addCase(sendLicenseInvoice.rejected, (state) => {
        state.isSendingInvoice = false;
      })
      .addDefaultCase((state) => state);
  }
});

export const actions = {
  ...sendLicenseInvoiceSlice.actions
};
export default sendLicenseInvoiceSlice.reducer;
